export default "__VITE_ASSET__59ea2982__"